define("shared/utils/media-adjustments/normalize", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.normalizeMediaAdjustments = normalizeMediaAdjustments;
  _exports.previewStatusOf = previewStatusOf;
  _exports.toRawMediaAdjustmentsHash = toRawMediaAdjustmentsHash;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /** The legacy flat preview fields some responses still send alongside (or instead of) `preview`. */

  /** Reads a platform adjustment's preview status, tolerating the legacy flat `preview_status` field. */
  function previewStatusOf(adjustment) {
    const record = adjustment;
    return adjustment.preview?.status ?? record.preview_status;
  }
  function normalizePreview(raw) {
    if (!raw || typeof raw !== 'object') {
      return {
        status: 'not_requested'
      };
    }
    const record = raw;
    const status = record.status ?? record.preview_status ?? 'not_requested';
    const url = record.url ?? record.preview_url;
    return url ? {
      status,
      url
    } : {
      status
    };
  }
  function normalizePlatformAdjustment(adjustment) {
    const record = adjustment;
    const previewSource = adjustment.preview ?? (record.preview_status ? {
      status: record.preview_status,
      url: record.preview_url,
      preview_url: record.preview_url
    } : undefined);
    return {
      violations: Array.isArray(adjustment.violations) ? adjustment.violations : [],
      adjusted: adjustment.adjusted_dimensions,
      preview: normalizePreview(previewSource)
    };
  }
  function normalizeMediaAdjustments(raw) {
    if (!raw || Object.keys(raw).length === 0) {
      return {
        platforms: {}
      };
    }
    const platforms = {};
    Object.entries(raw).forEach(_ref => {
      let [platformKey, adjustment] = _ref;
      platforms[platformKey] = normalizePlatformAdjustment(adjustment);
    });
    return {
      platforms
    };
  }
  function toRawMediaAdjustmentsHash(payload) {
    const raw = {};
    Object.entries(payload.platforms).forEach(_ref2 => {
      let [platformKey, adjustment] = _ref2;
      raw[platformKey] = {
        violations: adjustment.violations,
        adjusted_dimensions: adjustment.adjusted,
        preview: adjustment.preview
      };
    });
    return raw;
  }
});